import { Story } from '~/types'
import {
  hasPermission,
  Permissions,
} from '../../../modules/services/permission'

declare global {
  interface Window {
    userRolesAuth: Permissions
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function publishPermissions(story: Story) {
  const { story: storyAuth } = window.userRolesAuth
  // eslint-disable-next-line @typescript-eslint/camelcase
  const { canonical_website: website, additional_properties } = story

  const publicationAllowed = hasPermission(storyAuth.publish, website)
  const canInitialPublish =
    publicationAllowed || hasPermission(storyAuth.initialPublish, website)
  const canSubsequentPublish =
    publicationAllowed || hasPermission(storyAuth.subsequentPublish, website)

  const canPublish =
    publicationAllowed || canInitialPublish || canSubsequentPublish

  const canUnpublish = Boolean(
    hasPermission(storyAuth.unpublish) && additional_properties?.is_published
  )

  const canScheduleUnpublish = hasPermission(storyAuth.scheduleUnpublish)
  const canUnschedule = hasPermission(storyAuth.unpublish)

  return {
    canPublish,
    canSubsequentPublish,
    canInitialPublish,
    canUnpublish,
    canScheduleUnpublish,
    canUnschedule,
  }
}
